// Formát podle PriceFormat::format() v PHP: zaokrouhlení na haléře, mezera jako oddělovač tisíců,
// desetinná čárka, ",00" se vynechává. Měna se bere z konfigurace tenanta (fallback na překlad "czk").
// Prázdná hodnota (cena se ještě načítá) vrací prázdný řetězec.
const formatPrice = (price) => {
    const symbol = window.reservationConfig?.currencySymbol || window.translations.czk;
    if (price === null || price === undefined || price === '') {
        return '';
    }
    if (isNaN(Number(price))) {
        return price;
    }
    const rounded = Math.round((Number(price) || 0) * 100) / 100;
    const [whole, decimals] = Math.abs(rounded).toFixed(2).split('.');
    const number = (rounded < 0 ? '-' : '') + whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        + (decimals !== '00' ? ',' + decimals : '');

    return number + ' ' + symbol;
};

export default formatPrice;
